import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: authRoles.admin,
    routes: [
        {
            path: '/payment-status',
            component: FuseLoadable({
                loader: () => import('./PaymentStatusApp'),
            }),
        },
        {
            path: '/edit-payment-status/:id',
            component: FuseLoadable({
                loader: () => import('./MutatePaymentStatus'),
            }),
        },
    ],
};

export default [Index];
